import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { DEFAULT_LOCALE, isSupportedLocale } from '../../config/localeConfig';
import { isNonLocalizedPath } from './routeExclusions';

const LOCALE_COOKIE_KEY = 'pv_locale';

function getCookie(name) {
  if (typeof document === 'undefined') return null;

  const match = document.cookie.match(
    new RegExp('(^|;\\s*)' + name.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\$&') + '=([^;]*)')
  );

  return match ? decodeURIComponent(match[2]) : null;
}

function resolvePreferredLocale(fallback = DEFAULT_LOCALE) {
  const cookieLocale = getCookie(LOCALE_COOKIE_KEY);
  if (isSupportedLocale(cookieLocale)) return cookieLocale;

  return fallback;
}

export default function LanguageRedirect({
  to,
  replace = true,
  locale: forcedLocale,
}) {
  const location = useLocation();
  const params = useParams();

  if (isNonLocalizedPath(location.pathname)) {
    return null;
  }

  const routeLocale = params.locale || params.lang;
  const activeLocale = isSupportedLocale(routeLocale)
    ? routeLocale
    : isSupportedLocale(forcedLocale)
      ? forcedLocale
      : resolvePreferredLocale();

  const targetPath = typeof to === 'string' && to.length > 0 ? to : location.pathname;
  const normalizedTarget = targetPath.startsWith('/') ? targetPath : `/${targetPath}`;
  const search = location.search || '';
  const hash = location.hash || '';

  return (
    <Navigate
      to={`/${activeLocale}${normalizedTarget}${search}${hash}`}
      replace={replace}
    />
  );
}
